import { Routes } from '@angular/router';

/** `title` is a key of the message catalogue, resolved by `I18nTitleStrategy`. */
export const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'home' },
  {
    path: 'home',
    title: 'home',
    loadComponent: () => import('./pages/home/home').then((m) => m.Home),
  },
  {
    path: 'list',
    title: 'list',
    loadComponent: () => import('./pages/list/list').then((m) => m.List),
  },
  {
    path: '404',
    title: 'notFound',
    loadComponent: () => import('./pages/not-found/not-found').then((m) => m.NotFound),
  },
  {
    path: 'preview/:alias',
    title: 'preview',
    loadComponent: () => import('./pages/preview/preview').then((m) => m.Preview),
  },
  { path: '**', redirectTo: 'home' },
];

/**
 * The names the app answers to itself, which no cortito may take: in production
 * `main.py` resolves an alias before anything else, so a link called `home`
 * would answer for `corti.to/home` from then on.
 *
 * Only the first segment is reserved: an alias cannot contain a `/`, so
 * `preview/:alias` only ever takes the name `preview`.
 *
 * The routes above are the source of this list. The two `database.*.rules.json`
 * have to repeat it — rules are JSON and cannot read this file — and they are
 * what actually rejects the write. A test on each side fails if they ever
 * disagree.
 */
export const RESERVED_ALIASES = routes
  .map((route) => route.path?.split('/')[0])
  .filter((path) => !!path && path !== '**') as string[];
